<template>
<div>
    <b-row class="pt-4">
      <b-col>
        <h3>{{title}}</h3>
      </b-col>
    </b-row>
    
     <b-form @submit="onSubmit">
    
    <!-- Identification Immeuble  -->
    <hr />
    <!--<h5>{{$t('label.fiche.IdImmeuble')}}</h5>-->
    
    <div class="mt-2">
      <AlertSelectedUnit :selectedUnit="selectedUnit"/>
    </div>

    <div v-if="from === 'applicant'">
    
    <hr class="mt-4" v-if="form.inclusions || form.otherServices || form.promotions"/>
    <b-row>
    <b-col sm="4">
        <div class="mt-2" v-if="form.inclusions">
        <div><strong>{{ $t("label.fiche.inclusions") }}</strong> : </div>
        <b-row v-if="form.inclusions.length > 0">
          <!--<b-col v-for="(item, index) in form.inclusions" :key="`item.incl-${index}`" sm=3 class="mt-4">
            {{formatInclusion(item)}}
          </b-col>-->
          <b-col >
          {{formatInclusions()}}   
          </b-col>  
        </b-row> 
        </div>
    </b-col> 
    <b-col sm="4">
        <div class="mt-2" v-if="form.otherServices">
        <div><strong>{{ $t("label.fiche.otherServices") }}</strong> : </div>
        <b-row v-if="form.otherServices.InputOS">
          <b-col v-if="form.otherServices.InputOS.length > 0">
            <div v-for="(item) in form.otherServices.InputOS" :key="item.Id" >{{formatOtherServices(item)}}</div>
          </b-col>     
        </b-row>
        </div>
    </b-col>

      <b-col sm="4">
        <div class="mt-2" v-if="form.promotions">
        <div><strong>{{ $t("label.fiche.promotions") }}</strong> : </div>
        <b-row>
          <b-col>
            <div v-if="form.promotions.length > 0">
              <div v-for="(item) in form.promotions" :key="item.Id">{{item.value}}</div>
            </div>
          </b-col>
        </b-row>
        </div>
        </b-col>
      </b-row>
  <!-- Identification Candidat  -->
  <hr />
  </div>
    <h5>{{identification}}</h5>
  <b-row>
      <b-col sm=4 class="mt-4">
        <b-form-input v-model.trim="$v.form.fname.$model" :placeholder="$t('label.fiche.fname') + ' *'"></b-form-input>
        <div class="text-danger" v-if="!$v.form.fname.required && $v.form.fname.$dirty">{{ $t("info.required") }}</div>
        <div class="text-danger" v-if="!$v.form.fname.maxLength && $v.form.fname.$dirty">{{ $t("info.maxLength", [75]) }}</div>
      </b-col>
      <b-col sm=4 class="mt-4">
        <b-form-input v-model.trim="$v.form.lname.$model" :placeholder="$t('label.fiche.lname')+ ' *'"></b-form-input>
        <div class="text-danger" v-if="!$v.form.lname.required && $v.form.lname.$dirty">{{ $t("info.required") }}</div>
        <div class="text-danger" v-if="!$v.form.lname.maxLength && $v.form.lname.$dirty">{{ $t("info.maxLength", [75]) }}</div>
      </b-col>
      <b-col sm="4" class="mt-4">
        <datepicker input-class="datepicker" v-model.trim="$v.form.birthdate.$model" :placeholder="$t('label.fiche.birthdate')+ ' *'" :language="language" :disabledDates="disabledBirthdate"></datepicker>
        <div class="text-danger" v-if="!$v.form.birthdate.required && $v.form.birthdate.$dirty">{{ $t("info.required") }}</div>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm=4 class="mt-4">
        <b-form-input v-model.trim="$v.form.email.$model" :placeholder="$t('label.fiche.email')+ ' *'" :readonly="readonly"></b-form-input>
        <div class="text-danger" v-if="!$v.form.email.required && $v.form.email.$dirty">{{ $t("info.required") }}</div>
        <div class="text-danger" v-if="!$v.form.email.email && $v.form.email.$dirty">{{ $t("info.email") }}</div>
        <div class="text-danger" v-if="!$v.form.email.maxLength && $v.form.email.$dirty">{{ $t("info.maxLength", [75]) }}</div>
      </b-col>
      <b-col sm=4 class="mt-4">
        <b-form-input v-model.trim="$v.form.cell.$model" :placeholder="$t('label.fiche.phone')+ ' *'"></b-form-input>
        <div class="text-danger" v-if="!$v.form.cell.required && $v.form.cell.$dirty">{{ $t("info.required") }}</div>
        <div class="text-danger" v-if="!$v.form.cell.maxLength && $v.form.cell.$dirty">{{ $t("info.maxLength", [20]) }}</div>  
        <div class="text-danger" v-if="!$v.form.cell.minLength && $v.form.cell.$dirty">{{ $t("info.minLength", [9]) }}</div>    
      </b-col>
      <b-col sm=4 class="mt-4">
        <b-form-input v-model.trim="$v.form.phone.$model" :placeholder="$t('label.fiche.phone')"></b-form-input>
        <div class="text-danger" v-if="!$v.form.phone.maxLength && $v.form.phone.$dirty">{{ $t("info.maxLength", [20]) }}</div>
        <div class="text-danger" v-if="!$v.form.phone.minLength && $v.form.phone.$dirty">{{ $t("info.minLength", [9]) }}</div>
      </b-col>
    </b-row>

    <b-row>
        <b-col sm="4" class="mt-4">
          <b-form-select v-model.trim="$v.form.gender.$model" :options="genres"></b-form-select>
          <div class="text-danger" v-if="!$v.form.gender.required && $v.form.gender.$dirty">{{ $t("info.required") }}</div>
        </b-col> 
        <b-col sm="4" class="mt-4">
          <b-form-select v-model.trim="$v.form.civilStatus.$model" :options="civilStatusList"></b-form-select>
          <div class="text-danger" v-if="!$v.form.civilStatus.required && $v.form.civilStatus.$dirty">{{ $t("info.required") }}</div>
        </b-col>     
      </b-row>

    <b-row>
      <b-col class="mt-4">
        <b-form-group :label="$t('label.fiche.childPossession')" v-slot="{ ariaDescribedby }">
          <b-form-radio v-model.trim="$v.form.child.$model" :aria-describedby="ariaDescribedby" name="child" value="y">{{ $t("label.fiche.yes") }}</b-form-radio>
          <b-form-radio v-model.trim="$v.form.child.$model" :aria-describedby="ariaDescribedby" name="child" value="n">{{ $t("label.fiche.no") }}</b-form-radio>
        </b-form-group>
        <div class="text-danger" v-if="!$v.form.child.required && $v.form.child.$dirty">{{ $t("info.required") }}</div>
      </b-col>     
    </b-row>

    <b-row v-if="form.child === 'y'">
      <b-col v-for="(item, index) in form.childs" :key="`item.age-${index}`" sm=2 class="mt-4">
        <b-form-input maxlength="3" v-model="form.childs[index].age" :placeholder="$t('label.fiche.age')+ ' *'"></b-form-input>
        <!--<div class="text-danger" v-if="!$v.form.childs[index].age.required && $v.form.childs[index].age.$dirty">{{ $t("info.required") }}</div>-->
      </b-col>     
    </b-row>

    <div class="text-danger" v-if="childsValidation.status">{{ childsValidation.message }}</div>

    <div v-if="form.child === 'y'" class="mt-2">
      <b-button-group>
        <b-button variant="success" @click="addChild()">Add child</b-button>
        <b-button variant="danger" @click="removeChild()">Remove child</b-button>
      </b-button-group>
    </div>

    <hr />
    <h5>{{$t('label.fiche.addressCandidate')}}</h5>

  <b-row>
    <b-col sm="4" class="mt-4">
      <vue-google-autocomplete
      id="map"
      classname="form-control"
      :placeholder="$t('label.fiche.chooseAddress')"
      v-on:placechanged="getAddressData"
      country="ca"
      >
      </vue-google-autocomplete>
    </b-col>
  </b-row>

   <b-row>
      <b-col sm=3 class="mt-4">
        <b-form-input v-model.trim="$v.form.civic.$model" :placeholder="$t('label.fiche.civic')+ ' *'"></b-form-input>
        <div class="text-danger" v-if="!$v.form.civic.required && $v.form.civic.$dirty">{{ $t("info.required") }}</div>
        <div class="text-danger" v-if="!$v.form.civic.maxLength && $v.form.civic.$dirty">{{ $t("info.maxLength", [20]) }}</div>
      </b-col>
      <b-col sm=3 class="mt-4">
        <b-form-input v-model.trim="$v.form.street.$model" :placeholder="$t('label.fiche.street')+ ' *'"></b-form-input>
        <div class="text-danger" v-if="!$v.form.street.required && $v.form.street.$dirty">{{ $t("info.required") }}</div>
        <div class="text-danger" v-if="!$v.form.street.maxLength && $v.form.street.$dirty">{{ $t("info.maxLength", [75]) }}</div>
      </b-col>
      <b-col sm=3 class="mt-4">
        <b-form-input v-model.trim="$v.form.locality.$model" :placeholder="$t('label.fiche.locality')+ ' *'"></b-form-input>
        <div class="text-danger" v-if="!$v.form.locality.required && $v.form.locality.$dirty">{{ $t("info.required") }}</div>
        <div class="text-danger" v-if="!$v.form.locality.maxLength && $v.form.locality.$dirty">{{ $t("info.maxLength", [75]) }}</div>
      </b-col>
      <b-col sm=3 class="mt-4">
        <b-form-input v-model.trim="$v.form.app.$model" :placeholder="$t('label.fiche.app')"></b-form-input>
        <div class="text-danger" v-if="!$v.form.app.maxLength && $v.form.app.$dirty">{{ $t("info.maxLength", [20]) }}</div>
      </b-col>
    </b-row>

    <b-row>
        <b-col sm=3 class="mt-4">
        <b-form-input v-model.trim="$v.form.province.$model" :placeholder="$t('label.fiche.province')+ ' *'"></b-form-input>
        <div class="text-danger" v-if="!$v.form.province.required && $v.form.province.$dirty">{{ $t("info.required") }}</div>
        <div class="text-danger" v-if="!$v.form.province.maxLength && $v.form.province.$dirty">{{ $t("info.maxLength", [75]) }}</div>
      </b-col>
      <b-col sm=3 class="mt-4">
        <b-form-input v-model.trim="$v.form.country.$model" :placeholder="$t('label.fiche.country')+ ' *'"></b-form-input>
        <div class="text-danger" v-if="!$v.form.country.required && $v.form.country.$dirty">{{ $t("info.required") }}</div>
        <div class="text-danger" v-if="!$v.form.country.maxLength && $v.form.country.$dirty">{{ $t("info.maxLength", [75]) }}</div>
      </b-col>
      <b-col sm=3 class="mt-4">
        <b-form-input v-model.trim="$v.form.postal.$model" :placeholder="$t('label.fiche.postal')+ ' *'"></b-form-input>
        <div class="text-danger" v-if="!$v.form.postal.required && $v.form.postal.$dirty">{{ $t("info.required") }}</div>
        <div class="text-danger" v-if="!$v.form.postal.maxLength && $v.form.postal.$dirty">{{ $t("info.maxLength", [20]) }}</div>
      </b-col>
    </b-row>

    <!-- Experience de location avec Cogir -->

    <hr />
    <h5>{{$t('label.fiche.experienceCogir')}}</h5>

    <b-row>
      <b-col class="mt-4">
        <b-form-group :label="$t('label.fiche.experienceQuestion')" v-slot="{ ariaDescribedby }">
          <b-form-radio v-model.trim="$v.form.experienceCogir.$model" :aria-describedby="ariaDescribedby" name="experienceCogir" value="y">{{ $t("label.fiche.yes") }}</b-form-radio>
          <b-form-radio v-model.trim="$v.form.experienceCogir.$model" :aria-describedby="ariaDescribedby" name="experienceCogir" value="n">{{ $t("label.fiche.no") }}</b-form-radio>
        </b-form-group>
        <div class="text-danger" v-if="!$v.form.experienceCogir.required && $v.form.experienceCogir.$dirty">{{ $t("info.required") }}</div>
      </b-col>     
    </b-row>

    <div v-if="form.experienceCogir === 'y'">
    <div class="mt-4">Building 1</div>
    <hr />
    <b-row>
      <b-col sm=4 class="mt-4">
        <b-form-input v-model.trim="$v.form.buildingName1.$model" :placeholder="$t('label.fiche.buildingName')+ ' *'"></b-form-input>
        <div class="text-danger" v-if="!$v.form.buildingName1.required && $v.form.buildingName1.$dirty">{{ $t("info.required") }}</div>
        <div class="text-danger" v-if="!$v.form.buildingName1.maxLength && $v.form.buildingName1.$dirty">{{ $t("info.maxLength", [75]) }}</div>
      </b-col>
      <b-col sm=4 class="mt-4">
        <b-form-input v-model.trim="$v.form.completeAddress1.$model" :placeholder="$t('label.fiche.completeAddress')"></b-form-input>
        <div class="text-danger" v-if="!$v.form.completeAddress1.maxLength && $v.form.completeAddress1.$dirty">{{ $t("info.maxLength", [75]) }}</div>
      </b-col>
      <b-col sm=4 class="mt-4">
        <b-form-input v-model.trim="$v.form.rentedMonth1.$model" :placeholder="$t('label.fiche.rentedMonth')"></b-form-input>
        <div class="text-danger" v-if="!$v.form.rentedMonth1.numeric && $v.form.rentedMonth1.$dirty">{{ $t("info.numeric") }}</div>
        <div class="text-danger" v-if="!$v.form.rentedMonth1.minValue && $v.form.rentedMonth1.$dirty">{{ $t("info.minValue", [1]) }}</div>
        <div class="text-danger" v-if="!$v.form.rentedMonth1.maxValue && $v.form.rentedMonth1.$dirty">{{ $t("info.maxValue", [100000]) }}</div>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="3" class="mt-4">
        <datepicker input-class="datepicker" v-model="form.startDate1" :placeholder="$t('label.fiche.startDate')" :language="language" :disabledDates="disabledBirthdate"></datepicker>
        <b-button variant="link" @click="clearDateField('startDate1')">Clear dates field</b-button>
        <div class="text-danger" v-if="validateDateBetween1.status">{{ validateDateBetween1.message }}</div>
      </b-col>
      <b-col sm=3 class="mt-4">
        <datepicker input-class="datepicker" v-model="form.endDate1" :placeholder="$t('label.fiche.endDate')" :language="language" :disabledDates="disabledBirthdate"></datepicker>
        <b-button variant="link" @click="clearDateField('endDate1')">Clear dates field</b-button>
      </b-col>
      <b-col sm=3 class="mt-4">
        <b-form-input v-model.trim="$v.form.contactName1.$model" :placeholder="$t('label.fiche.contactName')"></b-form-input>
        <div class="text-danger" v-if="!$v.form.contactName1.maxLength && $v.form.contactName1.$dirty">{{ $t("info.maxLength", [75]) }}</div>
      </b-col>
      <b-col sm=3 class="mt-4">
        <b-form-input v-model.trim="$v.form.contactPhone1.$model" :placeholder="$t('label.fiche.contactPhone')"></b-form-input>
        <div class="text-danger" v-if="!$v.form.contactPhone1.minLength && $v.form.contactPhone1.$dirty">{{ $t("info.minLength", [9]) }}</div>
        <div class="text-danger" v-if="!$v.form.contactPhone1.maxLength && $v.form.contactPhone1.$dirty">{{ $t("info.maxLength", [20]) }}</div>
      </b-col>
    </b-row>

    <div class="mt-4">Building 2</div>
    <hr />
    <b-row>
      <b-col sm=4 class="mt-4">
        <b-form-input v-model.trim="$v.form.buildingName2.$model" :placeholder="$t('label.fiche.buildingName')"></b-form-input>
        <div class="text-danger" v-if="!$v.form.buildingName2.maxLength && $v.form.buildingName2.$dirty">{{ $t("info.maxLength", [75]) }}</div>
      </b-col>
      <b-col sm=4 class="mt-4">
        <b-form-input v-model.trim="$v.form.completeAddress2.$model" :placeholder="$t('label.fiche.completeAddress')"></b-form-input>
        <div class="text-danger" v-if="!$v.form.completeAddress2.maxLength && $v.form.completeAddress2.$dirty">{{ $t("info.maxLength", [75]) }}</div>
      </b-col>
      <b-col sm=4 class="mt-4">
        <b-form-input v-model.trim="$v.form.rentedMonth2.$model" :placeholder="$t('label.fiche.rentedMonth')"></b-form-input>
        <div class="text-danger" v-if="!$v.form.rentedMonth2.numeric && $v.form.rentedMonth2.$dirty">{{ $t("info.numeric") }}</div>
        <div class="text-danger" v-if="!$v.form.rentedMonth2.minValue && $v.form.rentedMonth2.$dirty">{{ $t("info.minValue", [1]) }}</div>
        <div class="text-danger" v-if="!$v.form.rentedMonth2.maxValue && $v.form.rentedMonth2.$dirty">{{ $t("info.maxValue", [100000]) }}</div>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="3" class="mt-4">
        <datepicker input-class="datepicker" v-model="form.startDate2" :placeholder="$t('label.fiche.startDate')" :language="language" :disabledDates="disabledBirthdate"></datepicker>
        <b-button variant="link" @click="clearDateField('startDate2')">Clear dates field</b-button>
        <div class="text-danger" v-if="validateDateBetween2.status">{{ validateDateBetween2.message }}</div>
      </b-col>
      <b-col sm=3 class="mt-4">
        <datepicker input-class="datepicker" v-model="form.endDate2" :placeholder="$t('label.fiche.endDate')" :language="language" :disabledDates="disabledBirthdate"></datepicker>
        <b-button variant="link" @click="clearDateField('endDate2')">Clear dates field</b-button>
      </b-col>
      <b-col sm=3 class="mt-4">
        <b-form-input v-model.trim="$v.form.contactName2.$model" :placeholder="$t('label.fiche.contactName')"></b-form-input>
        <div class="text-danger" v-if="!$v.form.contactName2.maxLength && $v.form.contactName2.$dirty">{{ $t("info.maxLength", [75]) }}</div>
      </b-col>
      <b-col sm=3 class="mt-4">
        <b-form-input v-model.trim="$v.form.contactPhone2.$model" :placeholder="$t('label.fiche.contactPhone')"></b-form-input>
        <div class="text-danger" v-if="!$v.form.contactPhone2.minLength && $v.form.contactPhone2.$dirty">{{ $t("info.minLength", [9]) }}</div>
        <div class="text-danger" v-if="!$v.form.contactPhone2.maxLength && $v.form.contactPhone2.$dirty">{{ $t("info.maxLength", [20]) }}</div>
      </b-col>
    </b-row>
           
    </div>

    <!-- Informations emploi -->

    <hr />
    <h5>{{$t('label.fiche.jobInformation')}}</h5>

    <b-row>
        <b-col sm=4 class="mt-4">
        <b-form-input v-model.trim="$v.form.employerName.$model" :placeholder="$t('label.fiche.employerName')"></b-form-input>
        <div class="text-danger" v-if="!$v.form.employerName.maxLength && $v.form.employerName.$dirty">{{ $t("info.maxLength", [75]) }}</div>
      </b-col>
      <b-col sm=4 class="mt-4">
        <b-form-input v-model.trim="$v.form.rhDirector.$model" :placeholder="$t('label.fiche.rhDirector')"></b-form-input>
        <div class="text-danger" v-if="!$v.form.rhDirector.maxLength && $v.form.rhDirector.$dirty">{{ $t("info.maxLength", [75]) }}</div>
      </b-col>
      <b-col sm=4 class="mt-4">
        <b-form-input v-model.trim="$v.form.employerPhone.$model" :placeholder="$t('label.fiche.employerPhone')"></b-form-input>
        <div class="text-danger" v-if="!$v.form.employerPhone.minLength && $v.form.employerPhone.$dirty">{{ $t("info.minLength", [9]) }}</div>
        <div class="text-danger" v-if="!$v.form.employerPhone.maxLength && $v.form.employerPhone.$dirty">{{ $t("info.maxLength", [20]) }}</div>
      </b-col>
    </b-row>
    <b-row>
        <b-col sm=4 class="mt-4">
        <b-form-input v-model.trim="$v.form.position.$model" :placeholder="$t('label.fiche.position')"></b-form-input>
        <div class="text-danger" v-if="!$v.form.position.maxLength && $v.form.position.$dirty">{{ $t("info.maxLength", [75]) }}</div>
      </b-col>
      <b-col sm=4 class="mt-4">
        <datepicker input-class="datepicker" v-model="form.employerStartDate" :placeholder="$t('label.fiche.startDate')" :language="language"></datepicker>
      </b-col>
      <b-col sm=4 class="mt-4">
        <b-form-input v-model.trim="$v.form.annualSalary.$model" :placeholder="$t('label.fiche.annualSalary')"></b-form-input>
        <div class="text-danger" v-if="!$v.form.annualSalary.numeric && $v.form.annualSalary.$dirty">{{ $t("info.numeric") }}</div>
        <div class="text-danger" v-if="!$v.form.annualSalary.minValue && $v.form.annualSalary.$dirty">{{ $t("info.minValue", [1]) }}</div>
        <div class="text-danger" v-if="!$v.form.annualSalary.maxLength && $v.form.annualSalary.$dirty">{{ $t("info.maxLength", [10]) }}</div>
      </b-col>
    </b-row>

    <!-- Informations emploi -->

    <hr />
    <h5>{{$t('label.fiche.otherIncome')}}</h5>

    <b-row>
        <b-col sm=3 class="mt-4">
          <b-form-checkbox
            id="emplInsurance"
            v-model="form.emplInsurance"
            name="emplInsurance"
            value="selected"
            unchecked-value=""
            @change="unchecked('emplInsurance', 'emplInsuranceAmount')"
          >
            {{$t('label.fiche.emplInsurance')}}
          </b-form-checkbox>

          <div v-if="form.emplInsurance === 'selected'">

            <b-form-input class="mt-2" v-model.trim="$v.form.emplInsuranceAmount.$model" :placeholder="$t('label.fiche.otherAmount')"></b-form-input>
            <div class="text-danger" v-if="!$v.form.emplInsuranceAmount.required && $v.form.emplInsuranceAmount.$dirty">{{ $t("info.required") }}</div>
            <div class="text-danger" v-if="!$v.form.emplInsuranceAmount.numeric && $v.form.emplInsuranceAmount.$dirty">{{ $t("info.numeric") }}</div>
            <div class="text-danger" v-if="!$v.form.emplInsuranceAmount.minValue && $v.form.emplInsuranceAmount.$dirty">{{ $t("info.minValue", [1]) }}</div>
            <div class="text-danger" v-if="!$v.form.emplInsuranceAmount.maxLength && $v.form.emplInsuranceAmount.$dirty">{{ $t("info.maxLength", [10]) }}</div>
          </div>
      </b-col>
      <b-col sm=3 class="mt-4">
          <b-form-checkbox
            id="welfare"
            v-model="form.welfare"
            name="welfare"
            value="selected"
            unchecked-value=""
            @change="unchecked('welfare', 'welfareAmount')"
          >
            {{$t('label.fiche.welfare')}}
          </b-form-checkbox>

          <div v-if="form.welfare === 'selected'">

            <b-form-input class="mt-2" v-model.trim="$v.form.welfareAmount.$model" :placeholder="$t('label.fiche.otherAmount')"></b-form-input>
            <div class="text-danger" v-if="!$v.form.welfareAmount.required && $v.form.welfareAmount.$dirty">{{ $t("info.required") }}</div>
            <div class="text-danger" v-if="!$v.form.welfareAmount.numeric && $v.form.welfareAmount.$dirty">{{ $t("info.numeric") }}</div>
            <div class="text-danger" v-if="!$v.form.welfareAmount.minValue && $v.form.welfareAmount.$dirty">{{ $t("info.minValue", [1]) }}</div>
            <div class="text-danger" v-if="!$v.form.welfareAmount.maxLength && $v.form.welfareAmount.$dirty">{{ $t("info.maxLength", [10]) }}</div>
          </div>
      </b-col>

      <b-col sm=3 class="mt-4">
          <b-form-checkbox
            id="CNESST"
            v-model="form.CNESST"
            name="CNESST"
            value="selected"
            unchecked-value=""
            @change="unchecked('CNESST', 'cnesstAmount')"
          >
            {{$t('label.fiche.CNESST')}}
          </b-form-checkbox>

          <div v-if="form.CNESST === 'selected'">

            <b-form-input class="mt-2" v-model.trim="$v.form.cnesstAmount.$model" :placeholder="$t('label.fiche.otherAmount')"></b-form-input>
            <div class="text-danger" v-if="!$v.form.cnesstAmount.required && $v.form.cnesstAmount.$dirty">{{ $t("info.required") }}</div>
            <div class="text-danger" v-if="!$v.form.cnesstAmount.numeric && $v.form.cnesstAmount.$dirty">{{ $t("info.numeric") }}</div>
            <div class="text-danger" v-if="!$v.form.cnesstAmount.minValue && $v.form.cnesstAmount.$dirty">{{ $t("info.minValue", [1]) }}</div>
            <div class="text-danger" v-if="!$v.form.cnesstAmount.maxLength && $v.form.cnesstAmount.$dirty">{{ $t("info.maxLength", [10]) }}</div>
          </div>
      </b-col>

      <b-col sm=3 class="mt-4">
          <b-form-checkbox
            id="retIncome"
            v-model="form.retIncome"
            name="retIncome"
            value="selected"
            unchecked-value=""
            @change="unchecked('retIncome', 'retIncomeAmount')"
          >
            {{$t('label.fiche.retIncome')}}
          </b-form-checkbox>

          <div v-if="form.retIncome === 'selected'">

            <b-form-input class="mt-2" v-model.trim="$v.form.retIncomeAmount.$model" :placeholder="$t('label.fiche.otherAmount')"></b-form-input>
            <div class="text-danger" v-if="!$v.form.retIncomeAmount.required && $v.form.retIncomeAmount.$dirty">{{ $t("info.required") }}</div>
            <div class="text-danger" v-if="!$v.form.retIncomeAmount.numeric && $v.form.retIncomeAmount.$dirty">{{ $t("info.numeric") }}</div>
            <div class="text-danger" v-if="!$v.form.retIncomeAmount.minValue && $v.form.retIncomeAmount.$dirty">{{ $t("info.minValue", [1]) }}</div>
            <div class="text-danger" v-if="!$v.form.retIncomeAmount.maxLength && $v.form.retIncomeAmount.$dirty">{{ $t("info.maxLength", [10]) }}</div>
          </div>
      </b-col>

      <b-col sm=3 class="mt-4">
          <b-form-checkbox
            id="otherIncome"
            v-model="form.otherIncome"
            name="otherIncome"
            value="selected"
            unchecked-value=""
            @change="unchecked('otherIncome', 'otherIncomeAmount')"
          >
            {{$t('label.fiche.otherIncome')}}
          </b-form-checkbox>

          <div v-if="form.otherIncome === 'selected'">

            <b-form-input class="mt-2" v-model.trim="$v.form.otherIncomeAmount.$model" :placeholder="$t('label.fiche.otherAmount')"></b-form-input>
            <div class="text-danger" v-if="!$v.form.otherIncomeAmount.required && $v.form.otherIncomeAmount.$dirty">{{ $t("info.required") }}</div>
            <div class="text-danger" v-if="!$v.form.otherIncomeAmount.numeric && $v.form.otherIncomeAmount.$dirty">{{ $t("info.numeric") }}</div>
            <div class="text-danger" v-if="!$v.form.otherIncomeAmount.minValue && $v.form.otherIncomeAmount.$dirty">{{ $t("info.minValue", [1]) }}</div>
            <div class="text-danger" v-if="!$v.form.otherIncomeAmount.maxLength && $v.form.otherIncomeAmount.$dirty">{{ $t("info.maxLength", [10]) }}</div>
          </div>
      </b-col>

    </b-row>

    <hr />
    <h5>{{$t('label.fiche.totalIncome')}}</h5>

    <b-row>
      <b-col sm=3 class="mt-4">
        <b-form-input class="mt-2" v-model.trim="$v.totalIncome.$model" :placeholder="$t('label.fiche.otherAmount')" readonly></b-form-input>
        <div class="text-danger" v-if="!$v.totalIncome.required && $v.totalIncome.$dirty">{{ $t("info.required") }}</div>
        <div class="text-danger" v-if="!$v.totalIncome.numeric && $v.totalIncome.$dirty">{{ $t("info.numeric") }}</div>
        <div class="text-danger" v-if="!$v.totalIncome.minValue && $v.totalIncome.$dirty">{{ $t("info.minValue", [1]) }}</div>
        <div class="text-danger" v-if="!$v.totalIncome.maxLength && $v.totalIncome.$dirty">{{ $t("info.maxLength", [10]) }}</div>
      </b-col>
    </b-row>

    <!-- Etudiant -->

    <hr />
    <h5>{{$t('label.fiche.student')}}</h5>

    <b-row>
      <b-col class="mt-4">
        <b-form-group :label="$t('label.fiche.studentQuestion')" v-slot="{ ariaDescribedby }">
          <b-form-radio v-model.trim="$v.form.studentQuestion.$model" :aria-describedby="ariaDescribedby" name="studentQuestion" value="y">{{ $t("label.fiche.yes") }}</b-form-radio>
          <b-form-radio v-model.trim="$v.form.studentQuestion.$model" :aria-describedby="ariaDescribedby" name="studentQuestion" value="n">{{ $t("label.fiche.no") }}</b-form-radio>
        </b-form-group>
        <div class="text-danger" v-if="!$v.form.studentQuestion.required && $v.form.studentQuestion.$dirty">{{ $t("info.required") }}</div>
      </b-col>     
    </b-row>

    <div v-if="form.studentQuestion === 'y'">
    <hr />
    <b-row>
      <b-col sm=3 class="mt-4">
        <b-form-input v-model.trim="$v.form.school.$model" :placeholder="$t('label.fiche.school')+' *'"></b-form-input>
        <div class="text-danger" v-if="!$v.form.school.required && $v.form.school.$dirty">{{ $t("info.required") }}</div>
        <div class="text-danger" v-if="!$v.form.school.maxLength && $v.form.school.$dirty">{{ $t("info.maxLength", [75]) }}</div>
      </b-col>
      <b-col sm=3 class="mt-4">
        <datepicker input-class="datepicker" v-model.trim="$v.form.startDate3.$model" :placeholder="$t('label.fiche.startDate')+' *'" :language="language"></datepicker>
        <b-button variant="link" @click="clearDateField('startDate3')">Clear dates field</b-button>
        <div class="text-danger" v-if="!$v.form.startDate3.required && $v.form.startDate3.$dirty">{{ $t("info.required") }}</div>
        <div class="text-danger" v-if="validateDateBetween3.status">{{ validateDateBetween3.message }}</div>
      </b-col>
      <b-col sm=3 class="mt-4">
        <datepicker input-class="datepicker" v-model="form.endDate3" :placeholder="$t('label.fiche.endDate')" :language="language"></datepicker>
        <b-button variant="link" @click="clearDateField('endDate3')">Clear dates field</b-button>
      </b-col>
      <b-col sm=3 class="mt-4">
        <b-form-input v-model.trim="$v.form.pretBourse.$model" :placeholder="$t('label.fiche.pretBourse')+' *'"></b-form-input>
        <div class="text-danger" v-if="!$v.form.pretBourse.required && $v.form.pretBourse.$dirty">{{ $t("info.required") }}</div>
        <div class="text-danger" v-if="!$v.form.pretBourse.numeric && $v.form.pretBourse.$dirty">{{ $t("info.numeric") }}</div>
        <div class="text-danger" v-if="!$v.form.pretBourse.minValue && $v.form.pretBourse.$dirty">{{ $t("info.minValue", [0]) }}</div>
        <div class="text-danger" v-if="!$v.form.pretBourse.maxLength && $v.pretBourse.$dirty">{{ $t("info.maxLength", [10]) }}</div>
      </b-col>
    </b-row>
    </div>

    <hr />
    <h5>{{$t('label.fiche.banque')}}</h5>

    <b-row>
      <b-col sm=6 class="mt-4">
        <b-form-input v-model.trim="$v.form.bankName.$model" :placeholder="$t('label.fiche.bankName')+' *'"></b-form-input>
        <div class="text-danger" v-if="!$v.form.bankName.required && $v.form.bankName.$dirty">{{ $t("info.required") }}</div>
        <div class="text-danger" v-if="!$v.form.bankName.maxLength && $v.form.bankName.$dirty">{{ $t("info.maxLength", [75]) }}</div>
      </b-col>
      <b-col sm=6 class="mt-4">
        <b-form-input v-model.trim="$v.form.bankAddress.$model" :placeholder="$t('label.fiche.bankAddress')+' *'"></b-form-input>
        <div class="text-danger" v-if="!$v.form.bankAddress.required && $v.form.bankAddress.$dirty">{{ $t("info.required") }}</div>
        <div class="text-danger" v-if="!$v.form.bankAddress.maxLength && $v.form.bankAddress.$dirty">{{ $t("info.maxLength", [75]) }}</div>
      </b-col>
    </b-row>

    <div v-if="from === 'applicant'">

    <hr />
    <h5>{{$t('label.fiche.personalRef')}}</h5>

    <div class="mt-4">Ref 1*</div>
    <hr/>

    <b-row>
      <b-col sm=4 class="mt-4">
        <b-form-input v-model.trim="$v.form.refName1.$model" :placeholder="$t('label.fiche.refName')+' *'"></b-form-input>
        <div class="text-danger" v-if="!$v.form.refName1.required && $v.form.refName1.$dirty">{{ $t("info.required") }}</div>
        <div class="text-danger" v-if="!$v.form.refName1.maxLength && $v.form.refName1.$dirty">{{ $t("info.maxLength", [75]) }}</div>
      </b-col>
      <b-col sm=4 class="mt-4">
        <b-form-input v-model.trim="$v.form.refAddress1.$model" :placeholder="$t('label.fiche.refAddress')+' *'"></b-form-input>
        <div class="text-danger" v-if="!$v.form.refAddress1.required && $v.form.refAddress1.$dirty">{{ $t("info.required") }}</div>
        <div class="text-danger" v-if="!$v.form.refAddress1.maxLength && $v.form.refAddress1.$dirty">{{ $t("info.maxLength", [75]) }}</div>
      </b-col>
      <b-col sm=4 class="mt-4">
        <b-form-input v-model.trim="$v.form.refCity1.$model" :placeholder="$t('label.fiche.refCity')+' *'"></b-form-input>
        <div class="text-danger" v-if="!$v.form.refCity1.required && $v.form.refCity1.$dirty">{{ $t("info.required") }}</div>
        <div class="text-danger" v-if="!$v.form.refCity1.maxLength && $v.form.refCity1.$dirty">{{ $t("info.maxLength", [75]) }}</div>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm=4 class="mt-4">
        <b-form-input v-model.trim="$v.form.refCell1.$model" :placeholder="$t('label.fiche.refPhone')+' *'"></b-form-input>
        <div class="text-danger" v-if="!$v.form.refCell1.required && $v.form.refCell1.$dirty">{{ $t("info.required") }}</div>
        <div class="text-danger" v-if="!$v.form.refCell1.minLength && $v.form.refCell1.$dirty">{{ $t("info.minLength", [9]) }}</div>
        <div class="text-danger" v-if="!$v.form.refCell1.maxLength && $v.form.refCell1.$dirty">{{ $t("info.maxLength", [20]) }}</div>
      </b-col>
      <b-col sm=4 class="mt-4">
        <b-form-input v-model.trim="$v.form.refPhone1.$model" :placeholder="$t('label.fiche.refPhone')"></b-form-input>
        <div class="text-danger" v-if="!$v.form.refPhone1.maxLength && $v.form.refPhone1.$dirty">{{ $t("info.maxLength", [20]) }}</div>
      </b-col>
    </b-row>

    <div v-if="from === 'applicant'">

    <div class="mt-4">Ref 2</div>
    <hr/>

    <b-row>
      <b-col sm=4 class="mt-4">
        <b-form-input v-model.trim="$v.form.refName2.$model" :placeholder="$t('label.fiche.refName')"></b-form-input>
        <div class="text-danger" v-if="!$v.form.refName2.maxLength && $v.form.refName2.$dirty">{{ $t("info.maxLength", [75]) }}</div>
      </b-col>
      <b-col sm=4 class="mt-4">
        <b-form-input v-model.trim="$v.form.refAddress2.$model" :placeholder="$t('label.fiche.refAddress')"></b-form-input>
        <div class="text-danger" v-if="!$v.form.refAddress2.maxLength && $v.form.refAddress2.$dirty">{{ $t("info.maxLength", [75]) }}</div>
      </b-col>
      <b-col sm=4 class="mt-4">
        <b-form-input v-model.trim="$v.form.refCity2.$model" :placeholder="$t('label.fiche.refCity')"></b-form-input>
        <div class="text-danger" v-if="!$v.form.refCity2.maxLength && $v.form.refCity2.$dirty">{{ $t("info.maxLength", [75]) }}</div>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm=4 class="mt-4">
        <b-form-input v-model.trim="$v.form.refCell2.$model" :placeholder="$t('label.fiche.refCell')"></b-form-input>
        <div class="text-danger" v-if="!$v.form.refCell2.maxLength && $v.form.refCell2.$dirty">{{ $t("info.maxLength", [20]) }}</div>
      </b-col>
      <b-col sm=4 class="mt-4">
        <b-form-input v-model.trim="$v.form.refPhone2.$model" :placeholder="$t('label.fiche.refPhone')"></b-form-input>
        <div class="text-danger" v-if="!$v.form.refPhone2.maxLength && $v.form.refPhone2.$dirty">{{ $t("info.maxLength", [20]) }}</div>
      </b-col>
    </b-row>

    </div>
     </div>

    <hr />

    <div><b-button class="mt-4" type="submit" variant="success" :disabled="disabled">{{ $t("label.submit") }}</b-button></div>

    </b-form>
    <!-- spinner -->
    <div v-if="spinner" class="text-center pt-2">
      <b-spinner style="width: 3rem; height: 3rem;" variant="success" label="Spinning" disabled="labelStatus"></b-spinner>
    </div>
    <!-- error -->
    <div v-if="error" class="pt-4">
        <b-alert sm="6" show variant="danger">
            <p>{{ error }}</p>
        </b-alert>
    </div>
  </div>
</template>

<script>
import { globalF } from './Helpers';
import { required, minLength, maxLength, email, numeric, minValue, maxValue } from 'vuelidate/lib/validators';
import axios from 'axios';
import moment from 'moment';
import VueGoogleAutocomplete from 'vue-google-autocomplete';
import Datepicker from 'vuejs-datepicker';
import {en, fr} from 'vuejs-datepicker/dist/locale';
import AlertSelectedUnit from './AlertSelectedUnit';

export default {
mixins: [globalF],
props: ['btnNextStep', 'from'],
data() { 
  return {
    spinner: false,
    disabled: false,
    error: "",
    form : {
      /*Building*/
      nomImeuble: this.getBuildName(),
      adresseImmeuble: this.getBuildAddress(),
      appartement: this.getBuildUnit(),
      rooms: this.getRooms(),
      loyer: this.getLoyer(),
      from: this.getFrom(),
      to: this.getTo(),
      inclusions: this.getBuildingsInclusions('Inclusions', [], 0),
      otherServices: this.getBuildingsInclusions('OtherServices', [], 0),
      promotions: this.getBuildingsInclusions('Promotions', [], 0),
      locAddress: "",
      /*Candidats*/
      fname: this.getData('fname', "", 1),
      lname: this.getData('lname', "", 1),
      birthdate: this.getData('birthdate', "", 1),
      cell: this.getData('cell', "", 1),
      phone: this.getData('phone', "", 1),
      email: this.getEmail(),
      /*Adresse candidat */
      civic: this.getData('civic',"", 1),
      street:this.getData('street',"", 1),
      locality: this.getData('locality',"", 1),
      app: this.getData('app',"", 1),
      province: this.getData('province',"", 1),
      country:this.getData('country',"", 1),
      postal: this.getData('postal',"", 1),
      civilStatus: this.getData('civilStatus',null, 1),
      gender: this.getData('gender',null, 1),
      child: this.getData('child',null, 1),
      childs: this.getAgesData('childs', 1),
      /*Expérience Cogir*/
      experienceCogir: this.getData('experienceCogir',null, 1),
      buildingName1: this.getData('buildingName1',"", 1),
      completeAddress1: this.getData('completeAddress1',"", 1),
      startDate1: this.getData('startDate1',"", 1),
      endDate1: this.getData('endDate1',"", 1),
      rentedMonth1: this.getData('rentedMonth1',"", 1),
      contactName1: this.getData('contactName1',"", 1),
      contactPhone1: this.getData('contactPhone1',"", 1),
      buildingName2: this.getData('buildingName2',"", 1),
      completeAddress2: this.getData('completeAddress2',"", 1),
      startDate2: this.getData('startDate2',"", 1),
      endDate2: this.getData('endDate2',"", 1),
      rentedMonth2: this.getData('rentedMonth2',"", 1),
      contactName2: this.getData('contactName2',"", 1),
      contactPhone2: this.getData('contactPhone2',"", 1),
      /* job information */
      employerName: this.getData('employerName',"", 1),
      rhDirector: this.getData('rhDirector',"", 1),
      position: this.getData('position',"", 1),
      employerPhone: this.getData('employerPhone',"", 1),
      employerStartDate: this.getData('employerStartDate',"", 1),
      annualSalary: this.getData('annualSalary',"", 1),
      emplInsurance: this.getData('emplInsurance',"", 1),
      emplInsuranceAmount: this.getData('emplInsuranceAmount',"", 1),
      welfare: this.getData('welfare',"", 1),
      welfareAmount: this.getData('welfareAmount',"", 1),
      CNESST: this.getData('CNESST',"", 1),
      cnesstAmount: this.getData('cnesstAmount',"", 1),
      retIncome: this.getData('retIncome',"", 1),
      retIncomeAmount: this.getData('retIncomeAmount',"", 1),
      otherIncome:this.getData('otherIncome',"", 1),
      otherIncomeAmount: this.getData('otherIncomeAmount',"", 1),
      school: this.getData('school',"", 1),
      startDate3: this.getData('startDate3',"", 1),
      endDate3: this.getData('endDate3',"", 1),
      pretBourse: this.getData('pretBourse',"", 1),
      studentQuestion: this.getData('studentQuestion',null, 1),
      bankName: this.getData('bankName',"", 1),
      bankAddress: this.getData('bankAddress',"", 1),

      refName1: this.getData('refName1',"", 1),
      refAddress1: this.getData('refAddress1',"", 1),
      refCity1: this.getData('refCity1',"", 1),
      refCell1: this.getData('refCell1',"", 1),
      refPhone1: this.getData('refPhone1',"", 1),

      refName2: this.getData('refName2',"", 1),
      refAddress2: this.getData('refAddress2',"", 1),
      refCity2: this.getData('refCity2',"", 1),
      refCell2: this.getData('refCell2',"", 1),
      refPhone2: this.getData('refPhone2',"", 1)
    }
  }
},
validations() {
        let dataToValidate = {
          totalIncome: {required, numeric, minValue: minValue(1), maxLength: maxLength(20)},
          form : {
            nomImeuble: {required,maxLength: maxLength(75)},
            adresseImmeuble: {required,maxLength: maxLength(75)},
            appartement: {required,maxLength: maxLength(75)},
            loyer: {required,maxLength: maxLength(75)},
            from: {required,maxLength: maxLength(75)},
            to: {required,maxLength: maxLength(75)},
            rooms: {required,maxLength: maxLength(75)},
            fname: {required,maxLength: maxLength(75)},
            lname: {required,maxLength: maxLength(75)},
            birthdate: {required},
            email: {required,email,maxLength: maxLength(75)},
            cell: {required, minLength: minLength(9), maxLength: maxLength(20)},
            phone:{minLength: minLength(9), maxLength: maxLength(20)},
            civic: {required,maxLength: maxLength(20)},
            street: {required,maxLength: maxLength(75)},
            locality: {required,maxLength: maxLength(75)},
            app: {maxLength: maxLength(20)},
            province: {required,maxLength: maxLength(75)},
            country: {required,maxLength: maxLength(75)},
            postal: {required,maxLength: maxLength(20)},
            civilStatus: {required},
            gender: {required},
            child: {required},
            experienceCogir: {required},
            employerName: {maxLength: maxLength(75)},
            rhDirector: {maxLength: maxLength(75)},
            position: {maxLength: maxLength(75)},
            employerPhone: {minLength: minLength(9),maxLength: maxLength(20)},
            annualSalary: {numeric, minValue: minValue(1), maxLength: maxLength(10)},
            studentQuestion: {required},
            bankName: {required, maxLength: maxLength(75)},
            bankAddress: {required, maxLength: maxLength(75)}
          }
        }

        if (this.from === 'applicant') {
          dataToValidate.form.refName1 = {required, maxLength: maxLength(75)};
          dataToValidate.form.refAddress1 = {required, maxLength: maxLength(75)};
          dataToValidate.form.refCity1 = {required, maxLength: maxLength(75)};
          dataToValidate.form.refCell1 = {required, minLength: minLength(9), maxLength: maxLength(20)};
          dataToValidate.form.refPhone1 = {maxLength: maxLength(20)};

          dataToValidate.form.refName2 = {maxLength: maxLength(75)};
          dataToValidate.form.refAddress2 = {maxLength: maxLength(75)};
          dataToValidate.form.refCity2 = {maxLength: maxLength(75)};
          dataToValidate.form.refCell2 = {minLength: minLength(9), maxLength: maxLength(20)};
          dataToValidate.form.refPhone2 = {minLength: minLength(9), maxLength: maxLength(20)};
        }

        if (this.form.experienceCogir === 'y') {
          dataToValidate.form.buildingName1 = {required, maxLength: maxLength(75)};
          dataToValidate.form.completeAddress1 = {maxLength: maxLength(75)};
          dataToValidate.form.rentedMonth1 = {numeric, minValue: minValue(1), maxValue : maxValue(10000)};
          dataToValidate.form.contactName1 = {maxLength: maxLength(75)};
          dataToValidate.form.contactPhone1 = {minLength: minLength(9),maxLength: maxLength(20)};

          dataToValidate.form.buildingName2 = {maxLength: maxLength(75)};
          dataToValidate.form.completeAddress2 = {maxLength: maxLength(75)};
          dataToValidate.form.rentedMonth2 = {numeric, minValue: minValue(1), maxValue : maxValue(10000)};
          dataToValidate.form.contactName2 = {maxLength: maxLength(75)};
          dataToValidate.form.contactPhone2 = {minLength: minLength(9), maxLength: maxLength(20)};
        }

        if (this.form.emplInsurance === 'selected') {
          dataToValidate.form.emplInsuranceAmount = {required, numeric, minValue: minValue(1), maxLength: maxLength(10)}
        }
        if (this.form.welfare === 'selected') {
          dataToValidate.form.welfareAmount = {required, numeric, minValue: minValue(1), maxLength: maxLength(10)}
        }
        if (this.form.CNESST === 'selected') {
          dataToValidate.form.cnesstAmount = {required, numeric, minValue: minValue(1), maxLength: maxLength(10)}
        }
        if (this.form.retIncome === 'selected') {
          dataToValidate.form.retIncomeAmount = {required, numeric, minValue: minValue(1), maxLength: maxLength(10)}
        }
        if (this.form.otherIncome === 'selected') {
          dataToValidate.form.otherIncomeAmount = {required, numeric, minValue: minValue(1), maxLength: maxLength(10)}
        }

        if (this.form.studentQuestion === 'y') {
          dataToValidate.form.school = {required, maxLength: maxLength(75)};
          dataToValidate.form.startDate3 = {required};
          dataToValidate.form.pretBourse = {required, numeric, minValue: minValue(0), maxLength: maxLength(10)}
        }

        return dataToValidate;
    },
mounted () {
    this.spinner = true;
    let promise = this.setAxios('Step1');
    promise.then(() => {
      this.spinner = false;
    });    
},
computed: {
  readonly: function () {
    let ro = true;
    if (this.from === 'endorser') {
      ro = false;
    }
    return ro;
  },
  title: function () {
    let label = this.$t('label.fiche.title');
    if (this.from === 'endorser') {
      label = this.$t('label.endorser');
    }
    return label;
  },
  identification: function () {
    let label = this.$t('label.fiche.Idprospect');
    if (this.from === 'endorser') {
      label = this.$t('label.IdEndorser');
    }
    return label;
  },
  selectedUnit: function () {
      let buldingsList = this.$store.getters.getBuildings;
      let prospectsUnits = this.$store.getters.getProspectsUnits;
      let selected = [];

      if (prospectsUnits.length > 0) {
        selected = prospectsUnits;
      }
      else {
        let processData = this.getUserProcessData(0);
        if (processData && processData.hasOwnProperty('selected')) {
          selected = processData.selected;
        }
      }

      /*if (selectedFromQueryString.length > 0) {
        selected = selectedFromQueryString;
      }*/

      
      let buildFormat = {};
      if (selected.length > 0) {
        let build = buldingsList.find(b => b.NOCIE === selected[0].NOCIE && b.NODIV === selected[0].NODIV && b.Immeuble.trim() === selected[0].IMMEUBLE.trim());
        buildFormat.name = build.NOMDIV+ " ("+  build.Street + ", " + build.City + ", " + build.Province+" )";
        buildFormat.unit = " # " +selected[0].UNITE;
        buildFormat.specs = {NBPIECE: selected[0].NBPIECE, publicUnitPrice: selected[0].publicUnitPrice, DATEENT: this.form.from, DATEEND: this.form.to};
      }
      
      return buildFormat;
    },
  childsValidation: function () {
    let obj = {status:false, message:""};
    if (this.form.child === 'y') {
      let childs = this.form.childs;
      for (let i=0; i < childs.length; i++) {
        if (childs[i].age == "") {
          obj.status = true;
          obj.message = this.$t('info.ageRequired');
        }
        else {
          if (isNaN(childs[i].age)) {
            obj.status = true;
            obj.message = this.$t('info.ageNumeric');
          }
          else {
            let age = parseInt(childs[i].age);
            if (age < 1 || age > 120) {
              obj.status = true;
              obj.message = this.$t('info.ageRange');
            }
          } 
        }        
      }
    }
    return obj;
  },
  validateDateBetween1: function () {
    let date1 = this.form.startDate1;
    let date2 = this.form.endDate1;

    return this.validateDateInterval(date1, date2);
  },
  validateDateBetween2: function () {
    let date1 = this.form.startDate2;
    let date2 = this.form.endDate2;

    return this.validateDateInterval(date1, date2);
  },
  validateDateBetween3: function () {
    let date1 = this.form.startDate3;
    let date2 = this.form.endDate3;

    return this.validateDateInterval(date1, date2);
  },
  url: function () {
    let urls = this.$store.getters.getUrlsList;
    return urls[process.env.VUE_APP_WHERE].json;
  },
  language: function () {
    return this.$i18n.locale === "fr" ? fr : en;
  },
  disabledBirthdate: function () {
    let myDate = moment().startOf('day').toDate();
    return {from: myDate};
  },
  civilStatusList: function () {
    return this.$t('label.fiche.civilStatus');
  },
  genres: function () {
    return [
      {value: null, text: this.$t('label.gender')+' *'},
      {value: 'm', text: this.$t('label.man')},
      {value: 'w', text: this.$t('label.woman')},
      {value: 'o', text: this.$t('label.other')}
    ];
  },
  totalIncome: function () {
      let total = 0; 
      let annualSalary = parseInt(this.form.annualSalary);
      let emplInsuranceAmount = parseInt(this.form.emplInsuranceAmount);
      let welfareAmount = parseInt(this.form.welfareAmount);
      let cnesstAmount = parseInt(this.form.cnesstAmount);
      let retIncomeAmount = parseInt(this.form.retIncomeAmount);
      let otherIncomeAmount = parseInt(this.form.otherIncomeAmount);

      if (!isNaN(annualSalary)) {
        total += annualSalary;
      }
      if (!isNaN(emplInsuranceAmount)) {
        total += emplInsuranceAmount;
      }
      if (!isNaN(welfareAmount)) {
        total += welfareAmount;
      }
      if (!isNaN(cnesstAmount)) {
        total += cnesstAmount;
      }
      if (!isNaN(retIncomeAmount)) {
        total += retIncomeAmount;
      }
      if (!isNaN(otherIncomeAmount)) {
        total += otherIncomeAmount;
      }
      
      return total;
  }
},
methods:{
  unchecked: function (model, modelAmount) {
    this.form[modelAmount] = "";
  },
  validateDateInterval: function (date1, date2) {
    let obj = {status:false, message:""};

    if (date1 && date2) {
      let pass = moment(date1).isBefore(moment(date2));
      obj = {status:!pass, message: this.$t('info.invalidDateRange')}
    }

    return obj;
  },
  clearDateField: function (model) {
    this.form[model] = "";
  },
  addChild() {
    if (this.form.childs.length < 12) {
      this.form.childs.push({age:""});
    }
  },
  removeChild() {
    if (this.form.childs.length > 1) {
      this.form.childs.pop();
    }
  },
  formatInclusion(Id) {
    let lg = this.$i18n.locale;
    let inclusions = this.$store.getters.getInclusions;
    let obj = inclusions.find(i => i.Id === Id);
    return lg === "fr" ? obj.fr : obj.en;
  },
  formatInclusions() {
    let lg = this.$i18n.locale;
    let inclusionsList = this.form.inclusions;
    let inclusionsLabel = this.$store.getters.getInclusions;
    let list = [];
    for (let i=0; i < inclusionsList.length; i++) {
      let obj = inclusionsLabel.find(l => l.Id === inclusionsList[i]);
      if (obj) {
        let value = lg === "fr" ? obj.fr : obj.en;
        list.push(value);
      }
    }

    return list.join(", ");
  },
  formatOtherServices(item) {
    let lg = this.$i18n.locale;
    let otherServices = this.$store.getters.getOtherServices;
    let obj = otherServices.find(i => i.Id === item.Id);

    let label = lg === "fr" ? obj.fr : obj.en;
    return label+" : "+item.value;
  },
  getBuildingsInclusions(property, defaultValue, int) {

    let buldingsList = this.$store.getters.getBuildings;
    
    let value = defaultValue;
    let processData = this.getProcessData(int);
    let selected = [];
    if (processData && processData.hasOwnProperty('selected')) {
        selected = processData.selected;
        let building = buldingsList.find(b => b.NOCIE === selected[0].NOCIE && b.NODIV === selected[0].NODIV);
        if (building.hasOwnProperty(property)) {
          let jsonString = building[property];
          try {
            value = JSON.parse(jsonString);
          }
          catch(err) {
            console.log(err);
          }
        }
    }

    return value;
  },
  /*Candidats */
  getEmail() {

    let user = this.$store.getters.getUser;
    let email = user.Email;

    if (this.from === 'endorser') {
      let emailValue = this.getData('email', '', 1);
      email = emailValue ? emailValue : "";
    }

    return email;
  },
  getData(property, defaultType, int) {
    let processData = this.getProcessData(int);
    let value = defaultType;
    if (processData && processData.hasOwnProperty(property)) {
      value = processData[property];
    }
    return value;
  },
  getAgesData(property, int) {
    let processData = this.getProcessData(int);
    let value = [{age:""}];
    if (processData && processData.hasOwnProperty(property)) {
      value = processData[property];
    }
    return value;
  },
  /*Building*/
  getUserProcessData(int) {

    let processData = this.$store.getters.getProcessData;
    
    let step0data = processData[int];
    return step0data;

  },
  getProcessData(int) {
    let processData = [];
    if (this.from === "endorser") {
      processData = this.$store.getters.getEndorserData;
      //int = 0;
    }
    else {
      processData = this.$store.getters.getProcessData;
    }
    let step0data = processData[int];
    return step0data;
 },
  getAddressData: function (addressData) {
    if (addressData) {
      this.form.locAddress = addressData;
      this.form.civic = addressData.hasOwnProperty('street_number') ? addressData.street_number : "";
      this.form.street = addressData.hasOwnProperty('route') ? addressData.route : "";
      this.form.locality = addressData.hasOwnProperty('locality') ? addressData.locality : "";
      this.form.province = addressData.hasOwnProperty('administrative_area_level_1') ? addressData.administrative_area_level_1 : "";
      this.form.country = addressData.hasOwnProperty('country') ? addressData.country : "";
      this.form.postal = addressData.hasOwnProperty('postal_code') ? addressData.postal_code : "";
    }
  },
  getBuildName() {
   let processData = this.getUserProcessData(0);
   let selected = "";
   if (processData && processData.hasOwnProperty('building')) {
        selected = processData.building.NOMDIV;
   }
    return selected;
 },
 getBuildAddress() {
   let buldingsList = this.$store.getters.getBuildings;
   let processData = this.getUserProcessData(0);
   let address = "";
   if (processData && processData.hasOwnProperty('building')) {
        let selected = processData.building;
        let building = buldingsList.find(b => b.NOCIE === selected.NOCIE && b.NODIV === selected.NODIV);
        address = building.Street +", "+building.City;
   }

   return address;
 },
 getBuildUnit() {
   let processData = this.getUserProcessData(0);
   let selected = "";
   if (processData && processData.hasOwnProperty('selected')) {
        selected = processData.selected[0].UNITE.trim();
   }
    return selected;
 },
 getRooms() {
   let processData = this.getUserProcessData(0);
   let selected = "";
   if (processData && processData.hasOwnProperty('selected')) {
        selected = processData.selected[0].NBPIECE.trim();
   }
    return selected;
 },
 getLoyer() {
   let processData = this.getUserProcessData(0);
   let loyer = "";
   if (processData && processData.hasOwnProperty('selected')) {
        loyer = processData.selected[0].publicUnitPrice;
   }
  return loyer;
 },
 getFrom() {
   let processData = this.getUserProcessData(0);
   let from = "";
   if (processData && processData.hasOwnProperty('startDate')) {
      let date = processData.startDate;
      from = moment(date.from).format('YYYY-MM-DD');
   }
  return from;
 },
 getTo() {
   let processData = this.getUserProcessData(0);
   let to = "";
   if (processData && processData.hasOwnProperty('startDate')) {
      let date = processData.startDate;
      to = moment(date.from).add(1, 'y').format('YYYY-MM-DD');
   }
  return to;
 },
 validateOthersData() {
   let pass = true;

   if (this.form.child === 'y') {
     if (this.childsValidation.status) {
       pass = false;
     }
   }

   if (this.validateDateBetween1.status) {
     pass = false;
   }
   if (this.validateDateBetween2.status) {
     pass = false;
   }
   if (this.validateDateBetween3.status) {
     pass = false;
   }

  return pass;
 },
 onSubmit(evt) {
      evt.preventDefault();
      this.$v.$touch();
      
      if (!this.$v.$invalid && this.validateOthersData()) { 
        let request = this.btnNextStep ? "updateRentalForm" : "addRentalForm";  
        if (this.from === "endorser") {
          request = this.btnNextStep ? "updateEndorserForm" : "addEndorserForm";
        }
        this.error = "";
        this.spinner = true;
        this.form.totalIncome = this.totalIncome;

            axios.post(this.url, {request: request, jsonData: JSON.stringify(this.form)  }, { headers: {'Content-Type': 'application/json'}})
                .then((response)  => {
                    this.spinner = false;

                    if (response.data.status === 0) {
                        window.location.reload(true);
                    }
                    else {
                        this.error = this.$t('info.errorgeneric');
                    }
                    
                })
                .catch(()  => {
                    this.error = this.$t('info.errorgeneric');
                    this.spinner = false;
                });
      }
    },
    setNextStep(step) {
      this.$emit('changeStep', step);
    },
    setNextPage(page) {      
      this.$emit('changePage', page);        
    }
},
components: {
    VueGoogleAutocomplete,
    Datepicker,
    AlertSelectedUnit
  }
}
</script>